import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoginOverlay } from '@bibliocommons/login';
import AuthActions from '../actions/AuthActions';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

const LoginOverlayContainer = ({
  authActions,
  loginOverlayOpen,
  loginErrorMessage,
  loading,
  numericPasswordRequired,
  getCardLink
}) =>
  (<LoginOverlay
    loginOverlayOpen={loginOverlayOpen}
    login={authActions.login}
    loginErrorMessage={loginErrorMessage}
    handleClose={authActions.closeLoginOverlay}
    loading={loading}
    numericPasswordRequired={numericPasswordRequired}
    getCardLink={getCardLink} />);

LoginOverlayContainer.propTypes = {
  authActions: PropTypes.shape({
    login: PropTypes.func,
    logout: PropTypes.func,
    loadUser: PropTypes.func,
    closeLoginOverlay: PropTypes.func
  }),
  loginErrorMessage: PropTypes.string,
  loginOverlayOpen: PropTypes.bool,
  loading: PropTypes.bool,
  numericPasswordRequired: PropTypes.bool,
  getCardLink: PropTypes.string
};

const mapDispatchToProps = dispatch =>
  ({
    authActions: bindActionCreators(AuthActions, dispatch)
  });

const mapStateToProps = state =>
  ({
    loginErrorMessage: state.getIn(['auth', 'loginErrorMessage']),
    loginOverlayOpen:  state.getIn(['auth', 'loginOverlayOpen']),
    loading: state.getIn(['auth', 'loading']),
    numericPasswordRequired: currentLibrarySelector(state).get('numericPasswordRequired'),
    getCardLink: currentLibrarySelector(state).get('getCardLink') || ''
  });

export default connect(mapStateToProps, mapDispatchToProps)(LoginOverlayContainer);



// WEBPACK FOOTER //
// ./app/containers/LoginOverlayContainer.jsx